"use strict";

var app = angular.module('app');

app.directive('shoppingCartFormPerson', function() {
    return {
        templateUrl: '/partials/directive/shopping-cart-form-person.htm'
    };
});